import $ from 'domtastic'
import * as Lozad from 'lozad'

import PolyfillIE from '../blocks/PolyfillIE'


const compsMap = {
    //
}




/* VIEW: BASEVIEW
---------------------------------------------------------------------------------------------------- */

export default class BaseView {

    constructor(props) {
        this.props     = props
        this.namespace = props.namespace
        this.comps     = {}

        this.scrollTop = 0


        swapVideoSources('.lazy')
        this.pollyfill = new PolyfillIE()
        this.initLazy()


        this.baseResizeHandler = () => { this.onResize() }
        this.baseScrollHandler = () => { this.onScroll() }
        this.baseUpdateLazyHandler = () => { this.updateLazy() }
        this.baseUpdateIEHandler = () => { this.updateIE() }


        this.bindBaseEvents()
        setTimeout(() => this.initComps(), 0)
    }


    bindBaseEvents() {
        $(document).on(`layoutChange${this.namespace}`, this.baseResizeHandler)
        $(document).on(`scroll${this.namespace}`, this.baseScrollHandler)
        $(document).on(`updateLazy${this.namespace}`, this.baseUpdateLazyHandler)
        $(document).on(`updateIE${this.namespace}`, this.baseUpdateIEHandler)
    }


    destroy() {
        if (!this.namespace) return


        $(window).off(this.namespace)
        $(document).off(this.namespace)
    }


    initComps() {
        $('[data-component]').each((el) => {
            const $el = $(el)

            const compName  = $el.attr('data-component').replace(/-|\s/g, '').toLowerCase()
            const compsList = compName.split(',')

            $el.removeAttr('data-component')

            compsList.forEach((c) => {
                if (compsMap[c]) {
                    if (!this.comps[c]) {
                        this.comps[c] = []
                    }

                    this.comps[c].push(new compsMap[c]($el, this.namespace, this))
                } else {
                    console.warn(`Component [${c}] not registered in BaseView.`)
                }
            })
        })
    }




    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        //
    }


    onScroll() {
        this.scrollTop = window.pageYOffset
    }




    /* Actions
    --------------------------------------------------------- */

    initLazy() {
        // ⚠️ Always init Lozad *after* IE polyfill
        this.lazyLoad = new Lozad('.lazy', {
            loaded: (lazyEl) => {
                lazyEl.classList.add('is-displaying')

                // remove class after lazy animation
                lazyEl.addEventListener('animationend', (el) => {
                    el.target.classList.remove('is-displaying')
                })
            },
        })

        this.lazyLoad.observe()
    }


    updateLazy() {
        this.updateIE()
        this.lazyLoad.observe()
    }


    updateIE() {
        this.pollyfill.bindElems()
        this.pollyfill.checkIE()
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */

const swapVideoSources = (selector) => {
    const mobileSource = APP.Browser.isMobile && APP.Layout.isMobile

    Array.from($(`video${selector}`)).forEach((video) => {
        const sources = video.children
        if (!sources) return

        for (let i = sources.length - 1; i >= 0; i--) {
            const srcPaths = sources[i].getAttribute('data-src').split(',')
            const srcType  = sources[i].getAttribute('type')

            const srcPath = (mobileSource && srcPaths.length > 1) ? srcPaths[1] : srcPaths[0]

            if (video.canPlayType(srcType)) {
                video.setAttribute('data-src', srcPath)
            }

            sources[i].src = srcPath
        }
    })
}



